import {
    Component,
    ojs,
    app,
    v,
    each,
    payload,
    state,
    component,
} from "modular-openscriptjs";
import {
    either,
    isMobile,
    getGreetings,
    formatDateForHumans,
    eParse,
    sendEvent,
    authenticated,
    formatThousand,
    getStore,
    store,
    deepEqual,
    fireEvent,
} from "../../helpers";
import { dom, tool } from "../../fotastart";
import { gc, uc, dc, api } from "../../declarations";
import MoreOptions from "../Blocks/MoreOptions";
import Announcements from "../Announcements";
import ErrandNameView from "./Errands/ErrandNameView";
import ProductNameView from "../Views/ProductNameView";
import FeaturedBusinesses from "./Businesses/FeaturedBusinesses";
import SuggestedUsers from "./Users/SuggestedUsers";
import AddProductForm from "../Forms/AddProductForm";
import Fab from "../Blocks/Fab";
import TopCategoryView from "./Search/TopCategoryView";
import AiCreditCard from "../Blocks/AiCreditCard";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

ojs(
    MoreOptions,
    Announcements,
    ErrandNameView,
    ProductNameView,
    FeaturedBusinesses,
    SuggestedUsers,
    Fab,
    TopCategoryView,
    AiCreditCard,
);

export default class AuthenticatedIndex extends Component {
    categoriesFetched = state(false);
    vkmModalHolder = null;

    $_mounted(componentId) {
        let c = component(componentId);
        if (!c) return;
        c.getCategories();
    }

    async getCategories() {
        if (this.categoriesFetched.value) return;

        // Load from cache first
        if (dc.categories.value.length === 0) {
            let cached = await getStore("categories");
            if (cached) {
                dc.categories.value = cached;
            }
        }

        try {
            let res = await api.get("/categories/top", {}, { silent: true });
            this.categoriesFetched.value = true;
            if (!res) return;

            let categories = res.data.categories;

            // Revalidate
            if (!deepEqual(categories, dc.categories.value)) {
                dc.categories.value = categories;
                store("categories", JSON.stringify(categories));
            }
        } catch (e) {
            console.error("Failed to load categories in index", e);
            this.categoriesFetched.value = true;
        }
    }

    showVkmInfo() {
        if (this.vkmModalHolder) {
            this.vkmModalHolder.hide();
        }

        let options = new tool.ModalOptions();
        options.buttons.right.visible = false;

        let modalBody = v(uc.subscription, (sub) => {
            const getProvision = (subVal, key, defaultVal = 0) => {
                const subProv = subVal?.provisions?.find((p) => p.key === key);
                if (subProv) return Number(subProv.value);
                const planProv = subVal?.plan?.provisions?.find(
                    (p) => p.key === key,
                );
                if (planProv) return Number(planProv.value);
                return defaultVal;
            };

            const vkmPerMinuteEffort = getProvision(
                sub.value,
                "virtual_distance_to_effort",
                0.15,
            );
            const effortVkm = (5 * vkmPerMinuteEffort).toFixed(2);

            return h.div(
                { class: "p-2 text-dark" },
                h.div(
                    { class: "d-flex align-items-start gap-3 mb-4" },
                    h.div(
                        {
                            class: "bg-warning bg-opacity-25 rounded-circle p-2 text-warning d-flex align-items-center justify-content-center flex-shrink-0",
                            style: "width: 48px; height: 48px;",
                        },
                        h.i({ class: "bi bi-lightning-charge-fill fs-4" }),
                    ),
                    h.div(
                        h.h5({ class: "fw-bold mb-1" }, "What is vKM?"),
                        h.p(
                            { class: "text-secondary mb-0 small" },
                            "vKM (virtual kilometres) is your prepaid delivery balance. It can only be used to pay for real deliveries from shops to your door.",
                        ),
                    ),
                ),
                h.div(
                    {
                        class: "card border-0 rounded-4 p-3 mb-4",
                        style: "background-color: #fcfcfc; border: 1px solid rgba(0,0,0,0.05)!important;",
                    },
                    h.h6(
                        {
                            class: "fw-bold mb-3 d-flex align-items-center gap-2",
                        },
                        h.i({ class: "bi bi-calculator text-primary" }),
                        "How a delivery is charged",
                    ),
                    h.div(
                        { class: "d-flex flex-column gap-2" },
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-between p-2 bg-white rounded-3 border",
                            },
                            h.span(
                                { class: "small text-secondary" },
                                "1 kilometer covered",
                            ),
                            h.span({ class: "fw-bold text-dark" }, "1.47 vKM"),
                        ),
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-between p-2 bg-white rounded-3 border",
                            },
                            h.span(
                                { class: "small text-secondary" },
                                "5 minutes effort",
                            ),
                            h.span(
                                { class: "fw-bold text-dark" },
                                `${effortVkm} vKM`,
                            ),
                        ),
                    ),
                ),
                h.div(
                    { class: "d-flex align-items-start gap-3" },
                    h.div(
                        {
                            class: "bg-info bg-opacity-25 rounded-circle p-2 text-info d-flex align-items-center justify-content-center flex-shrink-0",
                            style: "width: 48px; height: 48px;",
                        },
                        h.i({ class: "bi bi-check-circle-fill fs-4" }),
                    ),
                    h.div(
                        h.h6({ class: "fw-bold mb-1" }, "Every delivery is priced first"),
                        h.p(
                            { class: "text-secondary mb-0 small" },
                            "We work out the delivery fee from the distance, the size and weight of your order and the weather, convert that fee to vKM, and deduct it from your balance, at a heavily discounted rate.",
                        ),
                    ),
                ),
            );
        });

        let modal = tool.modal("Prepaid Delivery (vKM)", modalBody, options);

        this.vkmModalHolder = modal.modal.object;
    }

    renderSubscriptionSection() {
        return v(uc.subscription, (sub) => {
            const hasActiveSub = sub.value && sub.value.id;
            if (!hasActiveSub) {
                return h.div(
                    {
                        class: "card border-0 rounded-4 p-4 text-white shadow-sm animated-cta-card",
                        style: "cursor: pointer;",
                        onclick: () =>
                            sendEvent($e.subscription.needs.plans),
                    },
                    h.style(`
								@keyframes gradientShift {
									0% { background-position: 0% 50%; }
									50% { background-position: 100% 50%; }
									100% { background-position: 0% 50%; }
								}
								.animated-cta-card {
									background: linear-gradient(-45deg, #5d5fef, #8247e9, #4f46e5, #6366f1);
									background-size: 300% 300%;
									animation: gradientShift 8s ease infinite;
									border: none !important;
									box-shadow: 0 8px 24px rgba(93, 95, 239, 0.25) !important;
								}
								.animated-cta-card:hover {
									transform: translateY(-2px) scale(1.005) !important;
									box-shadow: 0 12px 30px rgba(93, 95, 239, 0.4) !important;
									transition: all 0.3s ease;
								}
							`),
                    h.div(
                        {
                            class: "d-flex align-items-center gap-3",
                            listeners: {
                                click: () => {
                                    fireEvent(
                                        $e.subscription.needs.plans,
                                    );
                                },
                            },
                        },
                        h.div(
                            {
                                class: "bg-dark bg-opacity-20 circle p-2 text-warning d-flex align-items-center justify-content-center",
                                style: "width: 48px; height: 48px;",
                            },
                            h.i({
                                class: "bi bi-lightning-charge-fill fs-4",
                            }),
                        ),
                        h.div(
                            h.h6(
                                { class: "fw-bold text-white mb-1" },
                                "The Smarter Way to Order",
                            ),
                            h.p(
                                {
                                    class: "text-white text-opacity-90 small mb-0",
                                },
                                "Subscribe to save over KES 2,300+ in delivery fees",
                            ),
                        ),
                    ),
                );
            }

            const vkmUsage = sub.value.usages?.find(
                (u) => u.feature_name === "virtual_distance",
            );
            const limit = vkmUsage ? Number(vkmUsage.limit) : 0;
            const used = vkmUsage ? Number(vkmUsage.used) : 0;
            const remaining = Math.max(0, limit - used);
            const pctUsed = limit > 0 ? (used / limit) * 100 : 0;
            const displayPct = Math.min(100, Math.ceil(pctUsed));

            return h.div(
                {
                    class: "card border-0 rounded-4 p-4 text-dark position-relative overflow-hidden shadow-sm",
                    style: "background-color: #ffffff; border: 1px solid rgba(0,0,0,0.06)!important;",
                    onclick: h.func("app('router').to", "user.subscriptions"),
                    role: 'button'
                },
                h.div(
                    {
                        class: "d-flex align-items-center justify-content-between mb-3",
                    },
                    h.div(
                        h.h6(
                            {
                                class: "text-uppercase fw-bold text-secondary mb-1",
                                style: "font-size: 0.72rem; letter-spacing: 0.5px;",
                            },
                            "Distance Remaining",
                        ),
                        h.h3(
                            {
                                class: "fw-bold mb-0 text-primary",
                                style: "color: #973e87!important;",
                            },
                            `${formatThousand(remaining.toFixed(1))} vKM`,
                        ),
                    ),
                    h.div(
                        {
                            class: "bg-light rounded-circle d-flex align-items-center justify-content-center border",
                            style: "width: 32px; height: 32px; cursor: pointer;",
                            onclick: this.method("showVkmInfo"),
                        },
                        h.i({
                            class: "bi bi-info-circle fs-6 text-secondary",
                        }),
                    ),
                ),
                h.div(
                    {
                        class: "w-100 bg-light rounded-pill overflow-hidden mb-2 border",
                        style: "height: 8px;",
                    },
                    h.div({
                        class: "h-100 rounded-pill",
                        style: `width: ${displayPct}%; background-color: #fed27d;`,
                    }),
                ),
                h.div(
                    {
                        class: "d-flex justify-content-between small text-secondary fw-semibold mb-2",
                    },
                    h.span(`${displayPct}% used`),
                    h.span(
                        formatThousand(used),
                        " / ",
                        formatThousand(limit),
                        " vKM used",
                    ),
                ),
                h.p(
                    {
                        class: "mb-0 fs-xsm fw-bold text-muted text-truncate",
                    },
                    remaining <= 0
                        ? "❌ Your prepaid delivery balance is used up"
                        : "💡 You can place orders",
                ),
            );
        });
    }

    renderCategoriesSection() {
        return h.div(
            { class: "categories-section" },
            h.h5(
                { class: "fw-bold mb-3 px-1 text-dark" },
                "Browse Categories",
            ),
            v(dc.categories, (categories) => {
                return h.div(
                    {
                        class: "d-flex flex-nowrap overflow-x-auto pb-2 gap-3 desktop-scrollbar",
                    },
                    h.call(() => {
                        if (categories.value.length === 0) {
                            return each([1, 2, 3, 4, 5], () =>
                                h.div(
                                    {
                                        class: "flex-shrink-0 bg-light placeholder-glow rounded-4",
                                        style: "width: 120px; height: 120px;",
                                    },
                                    h.div({
                                        class: "placeholder rounded-4 w-100 h-100",
                                    }),
                                ),
                            );
                        }

                        return each(categories.value, (cat) =>
                            h.div(
                                {
                                    class: "flex-shrink-0",
                                    style: "width: 140px;",
                                },
                                h.TopCategoryView(cat),
                            ),
                        );
                    }),
                );
            }),
        );
    }

    renderActionsSection() {
        return h.div(
            {
                class: "mb-5 mt-5 p-3 p-md-4 rounded-4 shadow-sm",
                style: "background-color: #ffd37e;",
            },
            h.div(
                { class: "row row-cols-2 row-cols-md-4 g-3 g-md-4" },

                // 1. Call to Order
                h.div(
                    { class: "col" },
                    h.div(
                        {
                            role: "button",
                            class: "actions-grid-card d-flex flex-column gap-1 align-items-center justify-content-center p-2 p-md-3 border-0 rounded-4 bg-white shadow-sm h-100 text-decoration-none",
                            style: "min-height: 120px;",
                            onclick: h.func("fireEvent", $e.voiceOrderCall.needs.start),
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-center mb-1",
                                style: "height: 52px;",
                            },
                            h.div(
                                {
                                    class: "rounded-circle d-flex align-items-center justify-content-center text-white shadow-sm",
                                    style: "width: 48px; height: 48px; background: linear-gradient(135deg, #34d399 0%, #059669 100%); box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);",
                                },
                                h.i({ class: "bi bi-telephone-fill fs-5" }),
                            ),
                        ),
                        h.span(
                            { class: "text-center fw-600 text-dark small" },
                            "Call to Order",
                        ),
                        h.span(
                            { class: "text-center text-secondary fs-xsm" },
                            "Order by Voice",
                        ),
                    ),
                ),

                // 2. Discover
                h.div(
                    { class: "col" },
                    h.div(
                        {
                            role: "button",
                            class: "actions-grid-card d-flex flex-column gap-1 align-items-center justify-content-center p-2 p-md-3 border-0 rounded-4 bg-white shadow-sm h-100 text-decoration-none",
                            style: "min-height: 120px;",
                            onclick: h.func(`app("router").to`, "app.search"),
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-center mb-1",
                                style: "height: 52px;",
                            },
                            h.img({
                                style: "max-height: 48px; max-width: 48px; object-fit: contain;",
                                src: `/assets/images/discover.webp`,
                                alt: "Discover",
                            }),
                        ),
                        h.span(
                            { class: "text-center fw-600 text-dark small" },
                            "Discover",
                        ),
                        h.span(
                            { class: "text-center text-secondary fs-xsm" },
                            "Food, Groceries & More",
                        ),
                    ),
                ),

                // 3. Carata Do
                h.div(
                    { class: "col" },
                    h.div(
                        {
                            role: "button",
                            class: "actions-grid-card d-flex flex-column gap-1 align-items-center justify-content-center p-2 p-md-3 border-0 rounded-4 bg-white shadow-sm h-100 text-decoration-none",
                            style: "min-height: 120px;",
                            onclick: h.func(
                                "fireEvent",
                                $e.deliveryRequest.needs.requestForm,
                            ),
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-center mb-1",
                                style: "height: 52px;",
                            },
                            h.img({
                                style: "max-height: 48px; max-width: 48px; object-fit: contain;",
                                src: `/assets/images/errands.webp`,
                                alt: "Carata Do",
                            }),
                        ),
                        h.span(
                            { class: "text-center fw-600 text-dark small" },
                            "Carata Do",
                        ),
                        h.span(
                            { class: "text-center text-secondary fs-xsm" },
                            "Package Delivery",
                        ),
                    ),
                ),

                // 4. Businesses
                h.div(
                    { class: "col" },
                    h.div(
                        {
                            role: "button",
                            class: "actions-grid-card d-flex flex-column gap-1 align-items-center justify-content-center p-2 p-md-3 border-0 rounded-4 bg-white shadow-sm h-100 text-decoration-none",
                            style: "min-height: 120px;",
                            onclick: h.func(
                                `app("router").to`,
                                "businesses",
                            ),
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-center mb-1",
                                style: "height: 52px;",
                            },
                            h.img({
                                style: "max-height: 48px; max-width: 48px; object-fit: contain;",
                                src: `/assets/images/shops.webp`,
                                alt: "Businesses",
                            }),
                        ),
                        h.span(
                            { class: "text-center fw-600 text-dark small" },
                            "Businesses",
                        ),
                        h.span(
                            { class: "text-center text-secondary fs-xsm" },
                            "Search Businesses",
                        ),
                    ),
                ),
            ),
        );
    }

    render(...args) {
        return h.div(
            { class: "pb-5 mb-5 container pt-md-5 pt-3" },
            // Mobile View
            h.div(
                { class: "d-block d-lg-none wrapper d-flex flex-column gap-4" },
                this.renderSubscriptionSection(),
                this.renderCategoriesSection(),
                this.renderActionsSection(),
                // Account-only widgets: bound to gc.auth so they show up
                // (and load their data) as soon as the user signs in, and
                // stay hidden for guests.
                h.Announcements(gc.auth),
                h.AiCreditCard(gc.auth),
            ),
            // Desktop View
            h.div(
                { class: "d-none d-lg-block wrapper" },
                h.div(
                    { class: "row g-4" },
                    // Main Column
                    h.div(
                        { class: "col-lg-7 col-xl-8 d-flex flex-column gap-4" },
                        this.renderSubscriptionSection(),
                        this.renderCategoriesSection(),
                        this.renderActionsSection(),
                    ),
                    // Sidebar Column
                    h.div(
                        { class: "col-lg-5 col-xl-4" },
                        h.div(
                            {
                                class: "position-sticky",
                                style: "top: 2rem;",
                            },
                            v(gc.auth, (auth) =>
                                either(auth.value, () =>
                                    h.h5(
                                        { class: "fw-bold mb-3 text-dark" },
                                        "Announcements",
                                    ),
                                ),
                            ),
                            h.div(
                                { class: "mb-4" },
                                h.Announcements(gc.auth),
                            ),
                            h.div({ class: "mb-4" }, h.AiCreditCard(gc.auth)),
                        ),
                    ),
                ),
            ),
            h.Fab([
                h.button(
                    {
                        class: "btn bg-white",
                        type: "button",
                        onclick: h.func(`app('router').to`, "companies.list"),
                    },
                    h.i({ class: "fa-solid fa-store" }),
                ),
                h.button(
                    {
                        class: "btn text-white",
                        style: "background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%);",
                        onclick: h.func("fireEvent", $e.product.needs.creation),
                    },
                    h.i({ class: "bi bi-stars" }),
                ),
            ]),
            ...args,
        );
    }

    $$app = {
        messages: {
            noUserToSuggest: (ed) => {
                let type = eParse(ed).message.get("type");
                dom.id(`c-index-sg-${type}`)?.classList.add("d-none");
            },
        },
    };

    repeatOrder(orderId) {
        if (!authenticated()) sendEvent($e.user.needs.authentication);
        broker.broadcast($e.order.needs.repeat, payload({ orderId }));
    }
}

ojs(AddProductForm);
